import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  standalone: false
})
export class LoadingComponent {
}
